type FilterGuestsProps = {
  guests: any[];
  search: string;
};

export const filterGuests = ({guests, search}: FilterGuestsProps) => {
  return guests.filter((guest) => guest.name.toLowerCase().includes(search.toLowerCase()));
};
